module.exports = __webpack_public_path__ + "img/jzgicon.89625c4d.svg";